<template>
  <p>Sorry, no {{searchType}} about "{{searchTerm}}" could be found. Please search again.</p>  
</template>

<script>
export default {
  name: "SearchNoResults",
  props: {
    searchTerm: {
      type: String
    },
    searchType: {
      type: String
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/components/searches/results/SearchNoResults.vue